/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Content_Step06_TeaserInputs */

const en_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Better shots from efficient motion, with less lifelong strain. The method is built for the long game.`)
};

const es_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejores golpes con un movimiento eficiente y menos desgaste a lo largo de la vida. El método está pensado para el largo plazo.`)
};

const de_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bessere Schläge durch effiziente Bewegung, mit weniger lebenslanger Belastung. Die Methode ist auf lange Sicht angelegt.`)
};

const zh_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高效的动作带来更好的击球，同时减少一生的身体负担。这套方法是为长久打球而设计的。`)
};

const ar_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضربات أفضل من حركة فعّالة، مع إجهاد أقل على مدى العمر. الطريقة مبنية للمدى الطويل.`)
};

const fr_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De meilleurs coups grâce à un mouvement efficace, avec moins de contraintes tout au long de la vie. La méthode est pensée pour durer.`)
};

const vi_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Những cú đánh tốt hơn từ chuyển động hiệu quả, với ít căng thẳng lâu dài hơn. Phương pháp được xây dựng cho cuộc chơi dài hơi.`)
};

const sw_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mipigo bora kutokana na mwendo wenye ufanisi, na mzigo mdogo kwa mwili maishani mwote. Mbinu hii imejengwa kwa ajili ya kucheza kwa miaka mingi.`)
};

const th_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ช็อตที่ดีขึ้นจากการเคลื่อนไหวที่มีประสิทธิภาพ พร้อมภาระต่อร่างกายตลอดชีวิตที่น้อยลง วิธีนี้สร้างขึ้นเพื่อการเล่นกอล์ฟในระยะยาว`)
};

const bs_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolji udarci iz efikasnog pokreta, uz manje doživotnog opterećenja. Metoda je građena za dugoročnu igru.`)
};

const ja_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`効率的な動きでより良いショットを。生涯にわたる体への負担はより少なく。このメソッドは長くプレーを続けるために作られています。`)
};

const ko_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`효율적인 동작이 더 좋은 샷을 만들고, 평생 몸에 쌓이는 부담은 줄여 줍니다. 이 방법은 오래도록 골프를 즐기기 위해 만들어졌습니다.`)
};

const pt_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tacadas melhores com movimentos eficientes e menos desgaste ao longo da vida. Um método pensado para o longo prazo.`)
};

const it_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colpi migliori grazie a un movimento efficiente, con meno fatica per il corpo nel corso della vita. Il metodo è pensato per giocare a lungo.`)
};

const sv_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bättre slag tack vare effektiv rörelse, med mindre belastning genom livet. Metoden är byggd för att hålla i längden.`)
};

const nl_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betere slagen dankzij efficiënte beweging, met minder belasting op de lange termijn. De methode is gebouwd om lang mee te gaan.`)
};

const da_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedre slag fra effektiv bevægelse, med mindre livslang belastning. Metoden er bygget til mange års spil.`)
};

const nb_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedre slag gjennom effektiv bevegelse, med mindre belastning gjennom livet. Metoden er bygget for å vare.`)
};

const fi_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parempia lyöntejä tehokkaasta liikkeestä ja vähemmän rasitusta koko eliniäksi. Menetelmä on rakennettu vuosien pelaamiseen.`)
};

const pl_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepsze uderzenia dzięki wydajnemu ruchowi i mniejsze obciążenie przez całe życie. Ta metoda jest stworzona z myślą o długiej grze.`)
};

const ru_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие удары благодаря эффективному движению и меньшая нагрузка на организм на протяжении всей жизни. Метод рассчитан на долгую игру.`)
};

const tr_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verimli hareketle daha iyi vuruşlar, ömür boyu daha az yük. Bu yöntem uzun vadeli oyun için tasarlandı.`)
};

const hi_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुशल गति से बेहतर शॉट, और जीवन भर शरीर पर कम दबाव। यह विधि लंबे समय तक खेलते रहने के लिए बनाई गई है।`)
};

const id_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pukulan yang lebih baik dari gerakan yang efisien, dengan beban seumur hidup yang lebih ringan. Metode ini dirancang untuk jangka panjang.`)
};

const ms_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pukulan yang lebih baik hasil gerakan yang cekap, dengan kurang tekanan pada badan sepanjang hayat. Kaedah ini dibina untuk jangka panjang.`)
};

const cs_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepší údery díky efektivnímu pohybu a menší celoživotní zátěž. Metoda je stavěná na dlouhá léta hraní.`)
};

const el_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Καλύτερα χτυπήματα χάρη στην αποδοτική κίνηση, με λιγότερη επιβάρυνση σε όλη τη ζωή. Η μέθοδος είναι φτιαγμένη για να παίζετε για πολλά χρόνια.`)
};

const he_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חבטות טובות יותר מתנועה יעילה, עם פחות עומס על הגוף לאורך החיים. השיטה בנויה למשחק לטווח ארוך.`)
};

const af_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beter houe van doeltreffende beweging, met minder lewenslange spanning. Die metode is gebou vir die lang spel.`)
};

const hu_injury_content_step06_teaser = /** @type {(inputs: Injury_Content_Step06_TeaserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb ütések a hatékony mozgásból, kevesebb egész életen át tartó terheléssel. A módszer hosszú távra épül.`)
};

/**
* | output |
* | --- |
* | "Better shots from efficient motion, with less lifelong strain. The method is built for the long game." |
*
* @param {Injury_Content_Step06_TeaserInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_content_step06_teaser = /** @type {((inputs?: Injury_Content_Step06_TeaserInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Content_Step06_TeaserInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_content_step06_teaser(inputs)
	if (locale === "de") return de_injury_content_step06_teaser(inputs)
	if (locale === "zh") return zh_injury_content_step06_teaser(inputs)
	if (locale === "ar") return ar_injury_content_step06_teaser(inputs)
	if (locale === "fr") return fr_injury_content_step06_teaser(inputs)
	if (locale === "vi") return vi_injury_content_step06_teaser(inputs)
	if (locale === "sw") return sw_injury_content_step06_teaser(inputs)
	if (locale === "th") return th_injury_content_step06_teaser(inputs)
	if (locale === "bs") return bs_injury_content_step06_teaser(inputs)
	if (locale === "ja") return ja_injury_content_step06_teaser(inputs)
	if (locale === "ko") return ko_injury_content_step06_teaser(inputs)
	if (locale === "pt") return pt_injury_content_step06_teaser(inputs)
	if (locale === "it") return it_injury_content_step06_teaser(inputs)
	if (locale === "sv") return sv_injury_content_step06_teaser(inputs)
	if (locale === "nl") return nl_injury_content_step06_teaser(inputs)
	if (locale === "da") return da_injury_content_step06_teaser(inputs)
	if (locale === "nb") return nb_injury_content_step06_teaser(inputs)
	if (locale === "fi") return fi_injury_content_step06_teaser(inputs)
	if (locale === "pl") return pl_injury_content_step06_teaser(inputs)
	if (locale === "ru") return ru_injury_content_step06_teaser(inputs)
	if (locale === "tr") return tr_injury_content_step06_teaser(inputs)
	if (locale === "hi") return hi_injury_content_step06_teaser(inputs)
	if (locale === "id") return id_injury_content_step06_teaser(inputs)
	if (locale === "ms") return ms_injury_content_step06_teaser(inputs)
	if (locale === "cs") return cs_injury_content_step06_teaser(inputs)
	if (locale === "el") return el_injury_content_step06_teaser(inputs)
	if (locale === "he") return he_injury_content_step06_teaser(inputs)
	if (locale === "af") return af_injury_content_step06_teaser(inputs)
	if (locale === "hu") return hu_injury_content_step06_teaser(inputs)
	return en_injury_content_step06_teaser(inputs)
});